import React, { useState, useEffect } from "react";
import { Box, Button, Stack } from "codekit";
import { useSearchReportsMutation } from "../../libs/redux/slices/Homenews/homenewsApiSlice";

const PublicPowerBIReport = () => {
  const [selected, setSelected] = useState(null);
  const [searchReportsPowerBi, { isLoading }] = useSearchReportsMutation();
  const [reports, setReports] = useState([]);
  const searchReports = async () => {
    try {
      const response = await searchReportsPowerBi().unwrap();
      const mappedReports = Array.isArray(response.data)
        ? response.data
            .filter((item) => item.regestxx === "ACTIVO") 
            .map((item, idx) => ({
              id: idx,
              key: item.nomvista ? item.nomvista.toLowerCase() : `reporte-${idx}`,
              name: item.nomvista || `Reporte ${idx + 1}`,
              url: item.linkvisx || "",
            }))
        : [];
      setReports(mappedReports);
    } catch (error) {
      setReports([]);
    }
  };
  useEffect(() => {
    searchReports();
  }, []);
  return (
    <Box>
      <Stack columns={5} gap={4} mb={6}>
        {reports.map((report) => (
          <Button
            key={report.id}
            variant={selected === report.key ? "white-secondary" : "secondary-bold"}
            onClick={() => setSelected(report.key)}
            style={
              selected === report.key
                ? { border: "2px solid #247EAB", color: "#247EAB" }
                : {}
            }
          >
            {report.name}
          </Button>
        ))}
      </Stack>

      {selected && (
        <iframe
          title="Power BI Report"
          width="100%"
          height="800"
          src={reports.find((r) => r.key === selected)?.url}
          frameBorder="0"
          allowFullScreen
        ></iframe>
      )}
    </Box>
  );
};

export default PublicPowerBIReport;
